import { NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';



@NgModule()
export class IconsModule
{
    /**
     * Constructor
     */
    constructor(
        private domSanitizer: DomSanitizer,
        private matIconRegistry: MatIconRegistry
    )    
    {

        const path = (url: string): SafeResourceUrl => this.domSanitizer.bypassSecurityTrustResourceUrl(url); 

        // Register icon sets
        this.matIconRegistry.addSvgIconSet(path('assets/icons/material-twotone.svg'));
        this.matIconRegistry.addSvgIconSetInNamespace('mat_outline', path('assets/icons/material-outline.svg'));
        this.matIconRegistry.addSvgIconSetInNamespace('mat_solid', path('assets/icons/material-solid.svg'));
        this.matIconRegistry.addSvgIconSetInNamespace('iconsmind', path('assets/icons/iconsmind.svg'));
        this.matIconRegistry.addSvgIconSetInNamespace('feather', path('assets/icons/feather.svg'));
        this.matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', path('assets/icons/heroicons-outline.svg'));
        this.matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', path('assets/icons/heroicons-solid.svg'));

        // register individual filetype icons
        const addFileType = (id: string, filename: string) =>
            this.matIconRegistry.addSvgIcon(id, path(`assets/icons/file-types/${filename}`));

        addFileType('file-type-pdf', 'pdf.svg');
        addFileType('file-type-csv', 'csv.svg');
        addFileType('file-type-doc', 'doc.svg');
        addFileType('file-type-docx', 'docx.svg');
        addFileType('file-type-jpeg', 'jpeg.svg');
        addFileType('file-type-jpg', 'jpg.svg');
        addFileType('file-type-png', 'png.svg');
        addFileType('file-type-txt', 'txt.svg');
        addFileType('file-type-xls', 'xls.svg');
        addFileType('file-type-xlsx', 'xlsx.svg');
        addFileType('file-type-blank', 'blank.svg');
        addFileType('file-type-folder', 'folder.svg');

    }
}
